/**
 * Dispatched to ask the lobby to navigate to a board *with* the cinematic
 * fly-through transition (whoosh + camera arc / opacity fade). Routes the
 * request through `LobbyClient.setActiveBoardId` so the swap-token bump
 * fires — a plain `router.push` skips the animation by design (passive
 * navigations stay silent).
 *
 * Detail payload uses lobby `MockBoard.id` namespace — the Boardroom is
 * keyed as `'boardroom'`, every other board uses its composite live grid
 * id (`<ugm>-<tokenId>`). Callers carrying a raw composite id should run
 * it through `lobbyBoardIdFromGridId` first.
 */
export const LOBBY_NAVIGATE_BOARD_EVENT = 'takeover:lobby-navigate-board';

export interface LobbyNavigateBoardDetail {
  boardId: string;
}
